//=====================================================
//　フォームボックス
//-----------------------------------------------------
//　フォームを作成するときは本コンポーネントがラップすること。
//　バリデーションチェック用の情報が用意されています。
//　バリデーション通過後の処理は引数に関数として渡してください。
//=====================================================
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

interface IFProps {
    children: any,
    useForm: UseFormReturn<FieldValues>
    successFunc: () => void,
    errorFunc?: () => void,
    className?:string
}

export function FormBox(props: IFProps){

    //バリデーション成功時の処理
    function submitSuccess(){
        props.successFunc();
    }

    //バリデーションエラー時の処理
    function submitError(){
        console.log(props.useForm.formState.errors);
        if( props.errorFunc ){
            props.errorFunc();
        }
    }

    return (
        <FormProvider {...props.useForm}>
            <form onSubmit={props.useForm.handleSubmit(submitSuccess, submitError)}>
                <div className={props.className !== undefined ? props.className : "form-box" }>
                    {props.children}
                </div>
            </form>
        </FormProvider>
    )

}